import $ from 'jquery';
import React,{useEffect} from 'react';
import {TableDatePicker} from '../function_lib/common_lib'; 

import StylusCanvas from '../lms_component/comp_stylus';
export function Comp_Add_STO(props){
    const getLatestDrawSignOne=(bImg)=>{
        $("#style_sign_one").val(bImg);

    }
    const getLatestDrawSignTwo=(bImg)=>{
        $("#style_sign_two").val(bImg);
    }
  //alert(JSON.stringify(props.editUser));
   useEffect(()=>{

   },[props.editUser]);
  
    return(<div className="modal fade bd-example-modal-xl"  id="divAddSTO" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Add New STO</h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmAddSTO" name="frmAddSTO">
       
        <div className="modal-body">
        <div className="row">
                  {/* <!-- left column --> */}
                  <div className="col-md-12">
                      <div className="card card-danger">
                              <input type="hidden" name="res_func" id="res_func" value={"okRespCreateUser"} />
                              <input type="hidden" name="curl_type" id="curl_type" value={"addSTO_CTOOfficer"} />
                              <input type="hidden" name="m_type" id="m_type" value={"addSTO_CTOOfficer"} />
                              <input type="hidden" name="log_id" id="log_id" value={props.logUser[0]["id"]}/>
                              <input type="hidden" name="log_app_id" id="log_app_id" value={props.logUser[0]["app_user_id"]}/>
                              <input type="hidden" name="type_id" id="type_id" value="2" />
                              <input type="hidden" name="type_master_id" id="type_master_id" value={btoa("11")}/>
                              <input type="hidden" name="user_info_id" id="user_info_id" value={typeof props.editUser.id !=="undefined"?btoa(props.editUser.id):"0"}/>
                              <input type="hidden" name="style_sign_one" id="style_sign_one"/>
                              <input type="hidden" name="style_sign_two" id="style_sign_two"/>
                              <div className="card-body">
                             
                              <div className="row">
                                 {/* Input fields */}
                              <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Officer Name *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="person_name" name="person_name" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                              
                              <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Email *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="email" name="email" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                </div>

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Contact No *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="contact_no" name="contact_no" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                            </div>

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Officer Rank (Position Held)</label>
                                            <div className="input-group input-group-sm">
                                            <select id="designation" name="designation" class="form-control required11">
                                            <option value={"0"}>-Select-</option>
                                            <option value={"Engineer"}>Engineer</option>
                                            <option value={"Deck Officer"}>Deck Officer</option>
                                          </select>
                                            </div>
                                        </div>
                            </div>

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Vessel Name</label>
                                            <div className="input-group input-group-sm">
                                            <input type="text" id="ship_name" name="ship_name" className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                            </div>

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">IMO No</label>
                                            <div className="input-group input-group-sm">
                                            <input type="text" id="imo_no" name="imo_no" className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                            </div>

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Owner's /Company Name </label>
                                            <div className="input-group input-group-sm">
                                            <input type="text" id="company_name" name="company_name" className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                            </div>

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">COC No </label>
                                            <div className="input-group input-group-sm">
                                            <input type="text" id="coc_number" name="coc_number" className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                            </div>

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">COC Grade </label>
                                            <div className="input-group input-group-sm">
                                            <select id="coc_grade" name="coc_grade" class="form-control required11">
                                            <option value={"0"}>-Select-</option>
                                            <option value={"Master FG"}>Master FG</option>
                                            <option value={"Master CE/FG"}>Master CE/FG</option>
                                          </select>
                                            
                                            </div>
                                        </div>
                            </div>

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">CDC Number *</label>
                                            <div className="input-group input-group-sm">
                                            <input type="text" id="cdc_number" name="cdc_number" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Indos Number *</label>
                                            <div className="input-group input-group-sm">
                                            <input type="text" id="indos_number" name="indos_number" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Date of Joining *</label>
                                            <div className="input-group input-group-sm">
                                            <TableDatePicker refName="doj" />
                                            </div>
                                        </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Date of SignOff *</label>
                                            <div className="input-group input-group-sm">
                                            <TableDatePicker refName="dos" />
                                            </div>
                                        </div>
                            </div>

                            
                            <div class="col-lg-4 col-md-4">


</div>
                           
                            <div class="col-lg-4 col-md-4">


                            </div>

                            {/* <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Digital Sign(1)</label>
                                            <div className="input-group input-group-sm">
                                            <StylusCanvas latestDraw={getLatestDrawSignOne}/>
                                            </div>
                                        </div>
                            </div> */}

                            {/* <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Digital Sign(2)</label>
                                            <div className="input-group input-group-sm">
                                            <StylusCanvas latestDraw={getLatestDrawSignTwo}/>
                                            </div>
                                        </div>
                            </div> */}
                           

                           
                              

                              {/* End of Input Fields */}
                              </div>
                                 
                                  <div className="col-md-6 respSSL"></div>
                                  <div id="testing2dd2222"></div>
                              </div>
                      </div>
                  </div>
              </div>
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" className="btn _btnSetColor btn-primary">Save</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}

export default Comp_Add_STO;